/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShopifyPalletBase
 */
export interface ShopifyPalletBase {
  /**
   *
   * @type {number}
   * @memberof ShopifyPalletBase
   */
  lengthInches: number;
  /**
   *
   * @type {number}
   * @memberof ShopifyPalletBase
   */
  widthInches: number;
}

/**
 * Check if a given object implements the ShopifyPalletBase interface.
 */
export function instanceOfShopifyPalletBase(
  value: object,
): value is ShopifyPalletBase {
  if (!("lengthInches" in value) || value["lengthInches"] === undefined)
    return false;
  if (!("widthInches" in value) || value["widthInches"] === undefined)
    return false;
  return true;
}

export function ShopifyPalletBaseFromJSON(json: any): ShopifyPalletBase {
  return ShopifyPalletBaseFromJSONTyped(json, false);
}

export function ShopifyPalletBaseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyPalletBase {
  if (json == null) {
    return json;
  }
  return {
    lengthInches: json["lengthInches"],
    widthInches: json["widthInches"],
  };
}

export function ShopifyPalletBaseToJSON(json: any): ShopifyPalletBase {
  return ShopifyPalletBaseToJSONTyped(json, false);
}

export function ShopifyPalletBaseToJSONTyped(
  value?: ShopifyPalletBase | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    lengthInches: value["lengthInches"],
    widthInches: value["widthInches"],
  };
}
